// Fetch wrapper that injects the Authorization header.
//
// USAGE: import this in tool API clients (imageStudioApi.js, blissApi.js)
// during Phase 3 — replace `fetch(...)` with `apiFetch(...)`. Until then,
// the existing tool clients keep using bare fetch and Lambdas are happy
// because the JWT authorizers aren't enforcing yet (Phase 3 lights them up).
//
// In dev mode (no token), this is a transparent passthrough.

import { authStore } from '../auth/authStore.js';

export async function apiFetch(url, init = {}) {
  const token = authStore.getIdToken();
  const headers = new Headers(init.headers || {});
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(url, { ...init, headers });
}
